import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import AlertService from '../../common/AlertService'

export const getScoreRangesCreditRisk = createAsyncThunk(
  'alerts/detail/score/getScoreRangesCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await AlertService.getScoreRangesCreditRisk(params)
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getScoreRangesPerformance = createAsyncThunk(
  'alerts/detail/score/getScoreRangesPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await AlertService.getScoreRangesPerformance(params)
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getCompanyInfo = createAsyncThunk(
  'alerts/detail/getCompanyInfo',
  async (params, { rejectWithValue }) => {
    try {
      const res = await AlertService.getCompanyInfo(params)
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const markAsReadAlert = createAsyncThunk(
  'alerts/detail/markAsReadAlert',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.markAsReadAlert(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getAlertDetails = createAsyncThunk(
  'alerts/detail/getAlertDetails',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getAlertDetails(params)

      if (response.success) return response.data

      return rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

export const getAlertList = createAsyncThunk(
  'alerts/detail/getAlertList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await AlertService.getAlertList(params)
      if (response.success) return response
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
